import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function sha256(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);

  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export const retry = async ({
  callback,
  retries = 3,
  delay = 1000,
  onRetry = () => {},
  onFailed = () => {},
}: {
  callback: () => Promise<void>;
  retries?: number;
  delay?: number;
  onRetry?: (attempt: number) => void;
  onFailed?: (error: unknown) => void;
}) => {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await callback();
    } catch (err) {
      if (attempt === retries) {
        onFailed(err);
        throw err;
      }

      const nextAttempt = attempt + 1;

      onRetry(nextAttempt);

      await new Promise((res) => setTimeout(res, delay * nextAttempt));
    }
  }
};
